/**
 * @flow
 * @relayHash 002f72693034e27a7a8ae7b8725cab0d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LogEmailVerifiedMutationInput = {|
  userId: string,
  clientMutationId?: ?string,
|};
export type LogEmailVerifiedMutationVariables = {|
  input: LogEmailVerifiedMutationInput
|};
export type LogEmailVerifiedMutationResponse = {|
  +logEmailVerified: ?{|
    +user: ?{|
      +id: string
    |}
  |}
|};
export type LogEmailVerifiedMutation = {|
  variables: LogEmailVerifiedMutationVariables,
  response: LogEmailVerifiedMutationResponse,
|};
*/


/*
mutation LogEmailVerifiedMutation(
  $input: LogEmailVerifiedMutationInput!
) {
  logEmailVerified(input: $input) {
    user {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogEmailVerifiedMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "logEmailVerified",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LogEmailVerifiedMutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LogEmailVerifiedMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "LogEmailVerifiedMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "LogEmailVerifiedMutation",
    "id": null,
    "text": "mutation LogEmailVerifiedMutation(\n  $input: LogEmailVerifiedMutationInput!\n) {\n  logEmailVerified(input: $input) {\n    user {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3b384ecf331d8d3428ffd5bbe22b78a9';
module.exports = node;
